import { initToolSelects } from './shared';

const TOOLS = {
    '2fa': () => import('./two-factor'),
    'multiple-urls': () => import('./multiple-urls'),
    'identify-data-format': () => import('./identify-data-format'),
    'base64-to-json': () => import('./base64-to-json'),
    'json-to-base64': () => import('./json-to-base64'),
    'netscape-cookies-to-json': () => import('./netscape-cookies-to-json'),
    'change-delimiter': () => import('./change-delimiter'),
    'split-by-delimiter': () => import('./split-by-delimiter'),
    'remove-duplicates': () => import('./remove-duplicates'),
    'social-post-preview': () => import('./social-post-preview'),
    'social-text-splitter': () => import('./social-text-splitter'),
    'hashtag-editor': () => import('./hashtag-editor'),
    'telegram-formatter': () => import('./telegram-formatter'),
    'link-cleaner': () => import('./link-cleaner'),
    'safe-zone-checker': () => import('./safe-zone-checker'),
};

const init = async () => {
    const page = document.querySelector('[data-tools-page]');

    if (!page) {
        return;
    }

    initToolSelects(page);

    const form = page.querySelector('[data-tool-form]');
    const tool = page.dataset.activeTool;
    const loadTool = TOOLS[tool];

    if (!form || !loadTool) {
        return;
    }

    const module = await loadTool();
    module.init(form);
};

document.addEventListener('DOMContentLoaded', init);
